/**
 * Marquee position — moves the announcement marquee to the top of the
 * page-wrapper on product pages only.
 *
 * Why JS instead of CSS: Savor's transparent-header logic on the home
 * page depends on `<main class="content-for-layout">` staying in the
 * box tree (the `body:has(.header[transparent])` and the first-section
 * margin rules all use `.content-for-layout > .shopify-section:first-child`).
 * The previous CSS approach (`display: contents` on main + `order: -1`
 * on the marquee section) broke that on the home page even with
 * `:has()` scoping, because some other Savor selectors still walk
 * through the .content-for-layout element. Moving the marquee in the
 * DOM via JS leaves the main element untouched on the home page and
 * only relocates the marquee on the product page where we want it.
 *
 * Result on product page:  marquee  →  header  →  product info
 * Result on home page:     (unchanged — transparent header keeps working)
 */
(function () {
  function positionMarquee() {
    // Only act on the product page (and any other page that opts in
    // by having a marquee in main). The home page has its marquee
    // disabled and the transparent header must stay intact there.
    if (document.body.dataset.template !== 'product') return;

    const marqueeComponent = document.querySelector('marquee-component');
    if (!marqueeComponent) return;

    const marqueeSection = marqueeComponent.closest('.shopify-section');
    if (!marqueeSection) return;

    const pageWrapper = document.querySelector('.page-wrapper');
    if (!pageWrapper) return;

    // Already at the top? Nothing to do.
    if (pageWrapper.firstElementChild === marqueeSection) return;

    // Move the marquee section to be the first child of page-wrapper,
    // so it renders above the header (which is the next child).
    pageWrapper.insertBefore(marqueeSection, pageWrapper.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionMarquee);
  } else {
    positionMarquee();
  }
})();
